const ITEMS = [
  "Empowering young minds",
  "Diverse children's books",
  "UK author visits",
  "Free classroom resources",
  "Rated 5.0 on Amazon UK",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-sand bg-creamdark/60 py-4 select-none" aria-hidden>
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 pr-8 font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-walnutmuted">
                {t}
                <span className="text-terracotta">✳</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
